import React, { useState, useEffect } from "react";
import { PostApi, GetApi, PutApi, getProfCliente, getDocCliente } from "../../services/auth.js";
import { Loading } from "../../helpers";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "../../componentes/ModalLegacy";
import { Cont } from "./styles";
import { Card, CardBody, Grid, Section, InputContainer, FormLabel, Alert, Container, CardFooter, CardHeader} from "uikit-react";
import UIkit from 'uikit';
import { DateFormatTNew, visible, formatCnpjCpf, validaCPF, validarCNPJ, MascaraCPNJCPF, FormatarParaReal } from "../../services/funcoes";
import ReactPaginate from 'react-paginate';
import Select from 'react-select'
import InputMask from 'react-input-mask';
import Swal from 'sweetalert2';

const Vagas = () => {
  const ListaStatus = [
    { value: 1, label: 'Disponível' },
    { value: 2, label: 'Contratada' },
    { value: 3, label: 'Cancelada' }
  ];
  const ListaHabilitacaox = [
    { value: 37, label: 'DISPONÍVEL PARA CONTRATAÇÃO' },
    { value: 36, label: 'NÃO DISPONÍVEL PARA CONTRATAÇÃO' },
    { value: 86480, label: 'EM FASE DE CONTRATAÇÃO' },
    { value: 86481, label: 'CONTRATADO' }
  ];
  const [ListaVagas, setListaVagas] = useState(false);
  const [NomeFiltro, setNomeFiltro] = useState("");
  const [StatusFiltro, setStatusFiltro] = useState("");
  const [StatusAcesso, setStatusAcesso] = useState("");
  const [StatusHabilitacao, setStatusHabilitacao] = useState(null);
  const [DataCadInicio, setDataCadInicio] = useState("");
  const [DataCadTermino, setDataCadTermino] = useState("");
  const [CNPJFiltro, setCNPJFiltro] = useState("");
  const [ModalAlteraStatus, setModalAlteraStatus] = useState(false);
  const [ModalAlteraStatusHabilitacao, setModalAlteraStatusHabilitacao] = useState(false);
  const [DadosVaga, setDadosVaga] = useState("");
  const [ListaEspecializacao, setListaEspecializacao] = useState([]);
  const [ListaHabilitacao, setListaHabilitacao] = useState([]);
  const [LoadingExportar, setLoadingExportar] = useState(false);

  //mensagem 
  const [mensagem, Setmensagem] = useState("Nenhuma informação encontrada. Por favor, verifique o filtro aplicado e tente novamente.");

  //Alert
  const [msg, SetMsg] = useState("");
  const [time, SetTime] = useState("");
  const [color, SetColor] = useState(""); //sucess, danger, warning
  const [AlertMsg, SetAlertMsg] = useState(false); 

  //Paginação
  const [itensPerPage, SetItensPerPage] = useState(25);
  const [currentPage, SetCurrentPage] = useState(1);
  const [pageCount, SetPageCount] = useState(0);
  const [pageTotal, SePageTotal] = useState(0);

  const MudaPaginaItens = async (e) => {  
    if(!isNaN(e.nextSelectedPage+1)){      
      SetCurrentPage(e.nextSelectedPage+1)
    }
  }; 

  useEffect(() => {
    GetListaVagas();
  },[currentPage, itensPerPage]);  
  
  useEffect(() => {  
    window.scrollTo(0, 0); 
  },[currentPage, itensPerPage]);
  
  useEffect(() => {  
    GetListaTipos();
    GetListaHabilitacoes();
  },[]);
  
  const GetListaTipos = async () => {
    const response = await GetApi('Cliente/ListaEspecificacoes?tipo=2479');
    if (response.status === 200) {
      var _ListaEspecializacao = [];
      for (var i = 0; i < response.data.dados.length; i++) {
        _ListaEspecializacao.push({
          value: response.data.dados[i].ProdissaoId,
          label: response.data.dados[i].ProfissaoDescricao
        });
      }
      setListaEspecializacao(_ListaEspecializacao);    
    }    
  };
  
  const GetListaHabilitacoes = async () => {
    const response = await GetApi('Filtros?Cad_tipo=35&Cad_ativo=1');
    if (response.status === 200) {
      var _ListaHabilitacao = [];
      for (var i = 0; i < response.data.filtros.length; i++) {
        _ListaHabilitacao.push({
          value: response.data.filtros[i].cad_cod,
          label: response.data.filtros[i].cad_descricao
        });
      }
      setListaHabilitacao(_ListaHabilitacao);    
    }    
  };
  
  const GetListaVagas = async () => {  
    setListaVagas(false);

    var FiltrosURL = "";
    if(NomeFiltro){
      FiltrosURL = FiltrosURL + "Nome=" + NomeFiltro.trim() + "&";
    }
    if(StatusFiltro && StatusFiltro !== null && StatusFiltro !== undefined && StatusFiltro.value !== null && StatusFiltro.value !== undefined){
      FiltrosURL = FiltrosURL + "VagaStatusId=" + StatusFiltro.value + "&";
    }
    if(DataCadInicio){
      FiltrosURL = FiltrosURL + "DataCad=" + DataCadInicio + "&";
    }
    if(DataCadTermino){
      FiltrosURL = FiltrosURL + "DataEncerramento=" + DataCadTermino + "&";
    }
    if(CNPJFiltro){
      FiltrosURL = FiltrosURL + "CNPJ=" + CNPJFiltro.replace(/\D/g, "") + "&";
    }

    const response = await GetApi('Admin/vaga/?' + FiltrosURL + 'Pagina=' + currentPage + '&TamanhoPagina=' + itensPerPage );
    if (response.status === 200) {
      response.data.vagas.forEach(element => {
        if(element.vagaStatusDescricao){ element.vagaStatusDescricao = element.vagaStatusDescricao.toLowerCase(); }
      })
      setListaVagas(response.data.vagas);
			SetPageCount(Math.ceil(response.data.totalRegistros / itensPerPage));
			SePageTotal(response.data.totalRegistros)
    } else {
      setListaVagas([])
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("danger");
      SetAlertMsg(true);
    }     
    
  };

  const AbreModalStatusVaga = async (dados) => {    
    setStatusAcesso(dados.statusId);
    setDadosVaga(dados);
    setModalAlteraStatus(true);
  };

  const FechaModalStatusVaga = () => {    
    setModalAlteraStatus(false);
    setTimeout(() => {
      setDadosVaga("");
    }, 1000);
  };

  const AlterarStatusVaga = async (item) => {

    var dados = {
      "vagaStatusId": 3
    }

    console.log('dados: ', dados);

    // return 

    const response = await PutApi('Admin/' + item.vagaId, dados);
    if (response.status === 200) {
      GetListaVagas();
      SetTime(4000);
      SetMsg("Vaga alterada com sucesso.");
      SetColor("success");
      SetAlertMsg(true);
      setModalAlteraStatus(false);
      setModalAlteraStatusHabilitacao(false);
    } else {
      SetTime(4000);
      SetMsg(response.data.mensagem || "Ocorreu um erro ao alterar o status da vaga.");
      SetColor("danger");
      SetAlertMsg(true);
      setModalAlteraStatus(false);
      setModalAlteraStatusHabilitacao(false);
    }
  };
  
  const ExportarDados = async () => {

    var FiltrosURL = "";
    if(NomeFiltro){
      FiltrosURL = FiltrosURL + "Nome=" + NomeFiltro.trim() + "&";
    }
    if(StatusFiltro && StatusFiltro !== null && StatusFiltro !== undefined && StatusFiltro.value !== null && StatusFiltro.value !== undefined){
      FiltrosURL = FiltrosURL + "VagaStatusId=" + StatusFiltro.value + "&";
    }
    if(DataCadInicio){
      FiltrosURL = FiltrosURL + "DataCad=" + DataCadInicio + "&";
    }
    if(DataCadTermino){
      FiltrosURL = FiltrosURL + "DataEncerramento=" + DataCadTermino + "&";
    }
    if(CNPJFiltro){
      FiltrosURL = FiltrosURL + "CNPJ=" + CNPJFiltro.replace(/\D/g, "") + "&";
    }

    setLoadingExportar(true);
    const response = await GetApi('Admin/vaga/excel?' + FiltrosURL + 'Pagina=' + currentPage + '&TamanhoPagina=' + itensPerPage );
    if (response.status === 200) {

    try {

      const base64 = response.data.arquivoExcel;
      const binaryString = window.atob(base64);
      const byteNumbers = new Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) { byteNumbers[i] = binaryString.charCodeAt(i); }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Vagas.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);

      SetTime(4000);
      SetMsg("Exportação concluída com sucesso!");
      SetColor("success");
      SetAlertMsg(true);
      setLoadingExportar(false);
    } catch (err) {
      console.error("Erro ao processar o Excel:", err);
      SetMsg("Erro ao processar o arquivo Excel.");
      SetColor("danger");
      SetAlertMsg(true);
      setLoadingExportar(false);
    }

      SetTime(4000);
      SetMsg("Exportação concluída com sucesso!");
      SetColor("success");
      SetAlertMsg(true);
      setLoadingExportar(false);
    } else {
      setLoadingExportar(false);
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("danger");
      SetAlertMsg(true);
    }
  };

  return (
    <Cont>    

      <Container size="expand" className="content-padder content-padder-inative" id="padder" >            
        <main className="uk-section">
          <Section className="uk-container uk-container-xlarge">  

              <Grid className="uk-flex uk-flex-middle uk-margin-medium">                
                <Section className="uk-width-expand">
                  <Section className="uk-inline">
                    <a className="uk-link-heading uk-flex uk-flex-middle">
                        <h4 className="uk-link-toggle uk-text-bold uk-margin-remove">
                          Vagas
                        </h4>
                    </a>
                  </Section>
                </Section>
              </Grid>  
                    
              <Card className="uk-margin-medium-bottom">
                <CardBody>
                  <Grid className="uk-grid-small">                 
                
                    {/* <Section className="uk-width-1-4@m">
                      <FormLabel className="uk-form-label">Nome</FormLabel>
                      <InputContainer>
                        <input
                          className="uk-input input"
                          type="text"
                          value={NomeFiltro}
                          onChange={e => setNomeFiltro(e.target.value)}
                        />
                      </InputContainer>
                    </Section> */}

                    <Section className="uk-width-1-4@m">
                      <InputContainer>
                        <FormLabel className="uk-form-label">CNPJ</FormLabel>
                        <InputMask mask="99.999.999/9999-99" maskChar=" " value={CNPJFiltro} onChange={(e) => setCNPJFiltro(e.target.value)}>
                          {() => (<input type="text" className="uk-input input" placeholder='' />)}
                        </InputMask>                                              
                      </InputContainer>
                    </Section>     

                    <Section className="uk-width-1-4@m">
                      <InputContainer>
                        <FormLabel className="uk-form-label">Data de cadastro</FormLabel>
                        <input                                   
                            className="uk-input input"
                            type="date"
                            value={DataCadInicio}                    
                            onChange={e => setDataCadInicio(e.target.value)}
                          />                                               
                      </InputContainer>
                    </Section> 

                    <Section className="uk-width-1-4@m">
                      <InputContainer>
                        <FormLabel className="uk-form-label">Data de Encerramento</FormLabel>
                        <input                                   
                            className="uk-input input"
                            type="date"
                            value={DataCadTermino}                    
                            onChange={e => setDataCadTermino(e.target.value)}
                          />                                               
                      </InputContainer>
                    </Section> 

                    <Section className="uk-width-1-4@m">
                      <InputContainer>
                        <FormLabel className="uk-form-label">Status</FormLabel>  
                          <Select
                            defaultValue={StatusFiltro}
                            onChange={setStatusFiltro}
                            options={ListaStatus}
                            placeholder={"..."}
                            isLoading={!ListaStatus.length}
                            className="basic-multi-select" 
                            classNamePrefix="uk-select"
                          />  
                      </InputContainer>
                    </Section>

                  </Grid>                              
                </CardBody>
              
                <CardFooter>
                  <Grid className="uk-grid-small uk-flex uk-flex-right">
                    <Section>
                      <button
                        type="button"                                            
                        id="Filtrar" 
                        className="uk-button uk-button-primary uk-float-right"                          
                        onClick={() => {GetListaVagas("Filtrar", "aguardeFiltro"); SetCurrentPage(1)}}        
                        value="Filtrar"   
                        //disabled={blockFiltro}                   
                      > 
                      <span  uk-icon="icon: search"></span> 
                        Filtrar                                        
                      </button>  

                      <button className="uk-button uk-button-primary" id="aguardeFiltro" style={{display:'none'}}>
                        <span uk-spinner="ratio: 0.5" className="uk-margin-small-right"></span> Aguarde
                      </button>  

                    </Section>
                  </Grid>                                                           
                </CardFooter> 
              </Card>                
            
              { AlertMsg === true && <Alert color={color} content={msg}  duration={time} onHide={() => SetAlertMsg(false)} isClosable /> } 

              <Card className="uk-card-default uk-margin">

                <CardHeader>
                  <Grid className="uk-flex uk-flex-middle">
                    <Section className="uk-width-expand">
                      <h4 className="uk-card-title">Lista de Vagas</h4>
                    </Section>
                    <Section className="uk-width-auto">
                      <Grid className="uk-flex uk-flex-right">
                        <Section>
                          {LoadingExportar ?
                          <button className="uk-button uk-button-link" type="button" disabled="disabled"><span uk-spinner="ratio: 0.5" className="uk-margin-small-right"></span> Aguarde</button>
                          :
                          <button className="uk-button uk-button-link" type="button" onClick={() => ExportarDados()}> <span uk-icon="icon: cloud-download"></span> Exportar </button>
                          }
                        </Section>
                      </Grid>
                    </Section>
                  </Grid>
                </CardHeader>

            { !ListaVagas ?
						<CardBody> <Loading /> </CardBody> 
            :
						<>
							<CardBody className="uk-child-width-expand@s uk-padding-small">
								<Section className="uk-margin-remove uk-padding-small uk-padding-remove-left uk-padding-remove-right">
									<div className="uk-overflow-auto">
										<table className="uk-table uk-table-divider uk-table-striped uk-table-small uk-text-small uk-table-middle  uk-table-hover">                                        
											<thead>
												<tr>  
													<th className="uk-text-left uk-table-shrink">Status</th>
													<th className="uk-text-left uk-table-shrink">CNPJ</th>
													<th className="uk-text-left uk-table-expand">Razão Social</th>
                          <th className="uk-text-left uk-table-expand">Data de Publicação</th>
                          <th className="uk-text-left uk-table-expand">Data de Encerramento</th>
													<th className="uk-text-left uk-table-shrink">Salário</th>
													<th className="uk-text-left uk-table-shrink">Especialização</th>
													<th className="uk-text-left uk-table-expand">UF - Cidade</th>
													<th className="uk-text-left uk-table-expand">CPF do Contratado</th>
													<th className="uk-text-center uk-table-shrink">Ação</th>
												</tr>
											</thead>                              
										<tbody>  
										{
											ListaVagas.length > 0 ?
												ListaVagas.map((item, index) => {

													return(
														<tr key={index}>             
															<td className="uk-text-nowrap">
                                <span className={`uk-label uk-text-capitalize ${item.vagaStatusId === 2 ? 'uk-label-success' : item.vagaStatusId === 1 ? 'uk-label-primary' : item.vagaStatusId === 3 ? 'uk-label-danger' : ''}`}>
                                  {item.vagaStatusDescricao}
                                </span>
															</td>              
															<td className="uk-text-nowrap">{MascaraCPNJCPF(item.cnpj)}</td>
															<td className="uk-text-nowrap">{item.razaoSocial || '-'}</td>
															<td className="uk-text-nowrap">{DateFormatTNew(item.dataCad)}</td>
															<td className="uk-text-nowrap">{DateFormatTNew(item.dataEncerramento)}</td>
															<td className="uk-text-nowrap">{item.salario ? FormatarParaReal(item.salario) : '-'}</td>
															<td className="uk-text-nowrap">{item.profissaoDescricao}</td>
															<td className="uk-text-nowrap">{item.estado} - {item.cidade}</td>
															<td className="uk-text-nowrap">{item.cpfContratado ? MascaraCPNJCPF(item.cpfContratado) : '-'}</td>
															<td className="uk-text-nowrap">
                                {item.vagaStatusId === 3 ? '-' : <button className="uk-icon-button" uk-icon="icon: pencil" uk-tooltip="title: Editar" onClick={() => AbreModalStatusVaga(item)} /> }
                              </td>
														</tr>
													) 
												})
											:
												<tr className="uk-text-center">
													<td colSpan={10}>
													{mensagem}
													</td>
												</tr>
										}
										</tbody>
									</table>
									</div>
								</Section>
							</CardBody>                          
							{
								ListaVagas.length > 0 &&  
								<CardFooter>
									<Grid className="uk-grid-small uk-flex uk-flex-middle uk-flex-right">
									<>
										<Section className="uk-flex uk-flex-middle">                      
										<span className="uk-margin-small-right">Itens por Página:</span>
										<InputContainer className="uk-form-controls">
											<select className="uk-select" id="form-horizontal-select" onChange={(e) => {SetItensPerPage(e.target.value); SetCurrentPage(1)}}>
												<option value={25} selected={itensPerPage === "25" ? "selected" : ""}>25</option>
												<option value={50} selected={itensPerPage === "50" ? "selected" : ""}>50</option>
												<option value={75} selected={itensPerPage === "75" ? "selected" : ""}>75</option>   
												<option value={100} selected={itensPerPage === "100" ? "selected" : ""}>100</option>                                        
											</select>
										</InputContainer>
										</Section>

										<Section>
										<>										

										<ReactPaginate
												nextLabel=" >"                                  
												onClick={(e) => MudaPaginaItens(e)}                                         
												pageRangeDisplayed={3}
												marginPagesDisplayed={1}
												forcePage={currentPage - 1}
												pageCount={pageCount}
												hrefAllControls={true}
												previousLabel="< "
												pageClassName="page-item"
												pageLinkClassName="page-link"
												previousClassName="page-item"
												// previousLinkClassName="page-link"
												nextClassName="page-item"
												// nextLinkClassName="page-link"
												breakLabel="..."
												breakClassName="page-item"
												breakLinkClassName="page-link"
												containerClassName="uk-pagination"
												activeClassName="uk-active"
												renderOnZeroPageCount={null}
											/>
										</>
										</Section>
									</> 
									</Grid>                                   
								</CardFooter>
							}
						</>
            }
              </Card>
        
          </Section>
        </main>
      </Container>  

      <Modal isOpen={ModalAlteraStatus} centered id="sm">
        <ModalHeader>{'Alteração de Status'}</ModalHeader>

        <ModalBody>         
            <p className="uk-margin-bottom">Tem certeza que deseja cancelar a vaga?</p>  
        </ModalBody>

        <ModalFooter>
          <Grid className="uk-grid-small uk-flex uk-flex-right">
            <Section>
              <button type="button" className="uk-button uk-button-default" onClick={() => FechaModalStatusVaga()}>
                <span uk-icon="icon: close"></span> Cancelar
              </button>
            </Section>
            <Section>
                <button type="button" id="deletar" className="uk-button uk-button-primary" onClick={() => AlterarStatusVaga(DadosVaga, "Acesso")}>
                  <span uk-icon="icon: check"></span> SIM! Cancelar Vaga
                </button>      
                        
                <button className="uk-button uk-button-primary" id="aguardeDelet" style={{display:'none'}} disabled>
                  <span uk-spinner="ratio: 0.5" className="uk-margin-small-right"></span> Aguarde
                </button>
              </Section>
          </Grid>
        </ModalFooter>
      </Modal>

    </Cont>
  );
}

export default Vagas;
